export const YES_NO_OPTIONS = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const mapToBoolean = (value: string | undefined): boolean | null => {
  if (!value) return null;

  if (value === 'true') {
    return true;
  }

  if (value === 'false') {
    return false;
  }

  return null;
};

export const mapToOptionalBoolean = (value: string | undefined) => mapToBoolean(value) ?? undefined;
